﻿<template>
    
  <div class="cart-summary w-full md:w-4/12 z-0">

    <transition name="fade">
      <div v-if="displayPopup" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div class="bg-white rounded-lg shadow-lg overflow-hidden w-11/12 md:w-2/3 lg:w-1/2 relative flex flex-col lg:flex-row">
          <div class="lg:w-1/2 bg-gray-100 flex items-center justify-center p-0">
            <img v-if="get_popup_image()" class="h-full w-full object-cover" :src="get_popup_image()" alt="Image of available Add-on" />
          </div>
          <div class="lg:w-1/2 p-6 text-center">
            <button class="absolute top-3 right-3 text-gray-500 hover:text-gray-700" @click="displayPopup=false">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <h3 class="text-xl font-semibold mb-2">{{get_popup_text()}}</h3>
            <p class="text-gray-600 mb-4">Add-ons are popular experiences that complement and enhance your trip. They sell out fast, so the purchase of tickets after checkout cannot be guaranteed.</p>
            <div class="flex flex-col md:flex-row lg:flex-col items-center justify-center space-y-2 md:space-y-0 md:space-x-2 lg:space-x-0 lg:space-y-2">
              <button class="button button-pink-book w-full md:w-auto lg:w-full px-2 py-1 md:px-4 md:py-2" @click="show_addons()">
                Show add-ons for my trip
              </button>
              <button class="button button-pink-book w-full md:w-auto lg:w-full px-2 py-1 md:px-4 md:py-2" @click="check_out()">
                Proceed without add-ons
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
   
    <div class="basket-summary">
      <itinerary_breakdown display_open=true></itinerary_breakdown>
      <hr />
      <trip_summary :show_percentage="true"></trip_summary>
      <trip_summary_discount v-if="get_Decimal_Total() > 1"></trip_summary_discount>
      <hr v-if="get_Decimal_Total() > 1"/>
      <div v-if="get_Decimal_Total() < 0" class="summary-total section">
        <div class="row">
          <h6 class="title text-base text-heading font-bold">Total Price</h6>
          <p class="text-black balance text-2xl text-action font-bold mb-0">{{ get_Total() }}<span class="font-normal text-lg"> {{ " " +get_Currency() }}</span><small class="font-normal text-sm"> includes all taxes.</small></p>
        </div>
      </div>
      <div class="summary-action section">
        <div class="row" :class="{ hidden: !get_Decimal_Total() || isAgent_Login() == true }">
          <p class="m-auto font-bold text-black">Check in closes 15 minutes before departure time. We are unable to hold the bus or refund for late arrivals.</p>
          <div class="flex my-4">
            <input v-model="agreeCheckbox" type="checkbox" class="focus:ring-action text-action border-grey-light rounded mr-5 mt-1 cursor-pointer">
            <label @click="agreeCheckbox = !agreeCheckbox" class="cursor-pointer">I understand and agree.</label>
          </div>
        </div>
        <div class="row">
          <button v-if="get_Decimal_Total() > 0 && agreeCheckbox" type="button" class="button button-pink-book full" @click="addons_Check()">
            <svg class="animate-spin h-5 w-5 mr-3 inline" :class="{ hidden: !booking_now }" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 512 512" stroke="currentColor">
              <path fill="currentColor" d="M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z" class=""></path>
            </svg>
            {{ checkout }}
          </button>
          <button v-if="get_Decimal_Total() < 1" type="button" class="border-grey-default bg-form border-blank button text-base text-action full" disabled>
            Cart Empty
          </button>
          <button v-if="get_Decimal_Total() > 0 && !agreeCheckbox" type="button" class="border-grey-default bg-form border-blank button text-base text-action full" disabled>
            Agree to continue
          </button>
        </div>
        <div class="row">
                    <small class="block mt-4 text-grey-default">{{get_Contact_Text()}}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" src="./summary.ts"></script>